import {APIResponse} from "../services/HttpService";
import {ApiDefinition} from "./ApiDefinition";
import {UserDTO} from "./model/user/UserDTO";

class UserSettingsApiDefinition extends ApiDefinition{
    constructor() {
        super("/users/settings");
    }

    async userInfo(): Promise<APIResponse<UserDTO>> {
        return this.get();
    }

    async supportedTimezones(): Promise<APIResponse<Record<string, string>>> {
        return this.get("/supported-timezones");
    }
}

// eslint-disable-next-line import/prefer-default-export
export const UserSettingsApi = new UserSettingsApiDefinition();